

export default function (event) {
    if (/[^0-9.]/.test(event.key)) {
        event.preventDefault();
    }
}